import React, { useState } from "react";
import SearchFrameMain from "./searchs/SearchFrameMain";
//import "./App.scss";
//import "./AppDev.scss";

//import configData from "./config.json";

import { socket } from "./socket";
import Loading from "./components/Loading2";
import { airportsIata } from "./airports";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpin from "react-loading-spin";
import {
  fetchRegionGroups,
  fetchDepartureStations,
  fetchTourOperators,
  fetchTravelAgencies,
  setBestplaces,
  getInfos,
  fetchSuggestions,
  getAdvertising,
  checkIban,
  checkAddressOrEmail,
  fetchAgencyproperties,
  fetchAirlines,
  fetchSessionHistory,
} from "amadeusredux/lib/propertiesSlice";

import HotelClassicViewView from "./hotel/HotelClassicViewView";
import HotelCrossViewView from "./hotel/HotelCrossViewView";
import OffersView from "./offers/OffersView";
import BookingView from "./booking/BookingView";

import {
  adultsOptions,
  airportcity,
  childrenAgeOptions,
  childrenOptions,
  getHost,
  getSocketHost,
  offerSortOptions,
  views,
} from "./utils";
import {
  setFeatures,
  setDebug,
  setSessionId,
  setUrlfound,
  setView,
  setSaveSearch,
  setSidebar,
  setMode,
} from "amadeusredux/lib/systemSlice";

import { useCookies } from "react-cookie";
import { v4 as uuidv4 } from "uuid";

import { parse, parseUrl } from "query-string";
import axios from "axios";
import {
  cookietosearch,
  memotosearch,
  search,
  setOfferMemo,
} from "amadeusredux/lib/api";
import {
  resetFilter,
  setApicall,
  setHolidayType,
  setInbounddate,
  setMid,
  setOutbounddate,
  setSearchOption,
  setSearchOptions,
  setSelectedDestination,
} from "amadeusredux/lib/searchSlice";
import TileView from "./tile/TileView";
import {
  setHotelOfferInfos,
  setHotelPage,
  setHotelSpecialRoomTypes,
  setOfferId,
  setSelectedHotel,
} from "amadeusredux/lib/hotelSlice";
import { addDays } from "date-fns";
import {
  getAllActions,
  getSuggestions,
  setOptionOperators,
} from "amadeusredux/lib/filterSlice";
import {
  setMemo,
  setSelectedOfferId,
  setSpecialRoomTypes,
} from "amadeusredux/lib/offersSlice";
import ConfirmationView from "./booking/ConfirmationView";
import { unwrapResult } from "@reduxjs/toolkit";
import FlightsView from "./flights/FlightsView";

const parsed = parse(window.location.search);

window.tileView = false;

if (window.location.href === window.configData.TILE_URL) {
  window.tileView = true;
}

if (!window.configData?.AGENCYID) {
  window.configData = {
    TILE_URL: "https://holiday.placelogg.com/themewordpress/",
    ACCOMMODATION_URL:
      "https://holiday.placelogg.com/themewordpress/?page_id=1596",
    PACKAGE_URL: "https://holiday.placelogg.com/themewordpress/?page_id=334",
    RESULTS_URL: "https://holiday.placelogg.com/themewordpress/?page_id=2348",
    AGENCYID: "2d03fadb-c6a9-46e0-a425-8103afa0004d",
  };
}

window.configData.TILE_URL = window.configData.TILE_URL.replace(
  "/index.php",
  ""
);
window.configData.ACCOMMODATION_URL =
  window.configData.ACCOMMODATION_URL.replace("/index.php", "");
window.configData.PACKAGE_URL = window.configData.PACKAGE_URL.replace(
  "/index.php",
  ""
);
window.configData.RESULTS_URL = window.configData.RESULTS_URL.replace(
  "/index.php",
  ""
);

//console.log(window.configData.AGENCYID);
axios.defaults.headers.common["AgencyID"] = window.configData.AGENCYID;

window.recognition = undefined;
/*eslint-disable */
const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;
const SpeechGrammarList =
  window.SpeechGrammarList || window.webkitSpeechGrammarList;
const SpeechRecognitionEvent =
  window.SpeechRecognitionEvent || window.webkitSpeechRecognitionEvent;

export default function App() {
  const dispatch = useDispatch();

  const appElement = React.useRef();

  const [cookies, setCookie] = useCookies(["amadeussession"]);

  window.setCookie = setCookie;

  const [parsedData, setParsedData] = useState(parsed);
  //const [loadanimation,setLoadanimation] = useState(false);
  const [cancelCounter, setCancelCounter] = useState(2);

  const view = useSelector((state) => state.system.view);
  const loading = useSelector((state) => state.system.loading);
  const memo = useSelector((state) => state.system.memo);
  const hotelCount = useSelector((state) => state.filter.hotelCount);
  //const ibanresult = useSelector((state) => state.properties.ibanresult);
  //const addressresult = useSelector((state) => state.properties.addressresult);

  const [recognised, setRecognised] = useState("");
  const [currentText, setCurrenttext] = useState("");

  //console.log(ibanresult);

  /*eslint-enable */

  const changeRecognised = (change) => {
    setRecognised(recognised + " " + change);
  };

  const [isConnected, setIsConnected] = useState(socket.connected);

  React.useEffect(() => {
    function onConnect() {
      setIsConnected(true);
    }

    function onDisconnect() {
      setIsConnected(false);
      //console.log("disconnect");
    }

    function onWelcome(msg) {
      //console.log(msg);
    }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("welcome", onWelcome);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("welcome", onWelcome);
    };
  }, []);

  React.useEffect(() => {
    if (SpeechRecognition) {
      //console.log(">>>>>>>>>>>rec");
      window.recognition = new SpeechRecognition();
    }
    dispatch(fetchAgencyproperties());
    dispatch(getAllActions());
    dispatch(getInfos({ context: "searchframemain" }));
    dispatch(getInfos({ context: "adults_only" }));
    dispatch(getInfos({ context: "aktionszimmer_ausblenden" }));
    dispatch(getInfos({ context: "classicview" }));
    dispatch(getInfos({ context: "connectsymbol" }));
    dispatch(getInfos({ context: "crosscheck" }));
    dispatch(getInfos({ context: "einige_tage_ohne_anzahlung_reservieren" }));
    dispatch(getInfos({ context: "favoritensymbol" }));
    dispatch(getInfos({ context: "ink_hoteltransfer_im_zielgebiet" }));
    dispatch(getInfos({ context: "ink_mietwagen" }));
    dispatch(getInfos({ context: "kostenlose_umbuchung" }));
    dispatch(getInfos({ context: "flex_option_zubuchbar" }));
    dispatch(getInfos({ context: "kostenlos_oder_günstig_stornierbar" }));
    dispatch(getInfos({ context: "pool_access" }));
    dispatch(getInfos({ context: "sofortige_festbuchung" }));
    dispatch(getInfos({ context: "zug_zum_flug_inklusive" }));
    dispatch(getInfos({ context: "roomtypinfo" }));
    dispatch(getInfos({ context: "uploadsymbol" }));
    dispatch(getInfos({ context: "hotel_check_in" }));
    dispatch(getInfos({ context: "luggage" }));
    dispatch(getInfos({ context: "checked" }));
    dispatch(getInfos({ context: "couponrequest" }));
    dispatch(getInfos({ context: "postcoderequest" }));
  }, []);

  React.useEffect(() => {
    if (SpeechRecognition) {
      //console.log(">>>>>>>>>>>rec");
      window.recognition = new SpeechRecognition();
      window.recognition.continuous = false;
      window.recognition.lang = "de-DE";
      window.recognition.interimResults = true;
      /*recognition.onstart = function () {
        //console.log("qwe");
        inst.props.systemShowMic(false);
      };
      recognition.onend = function () {
        //console.log("qwe1");
        inst.props.systemShowMic(true);
      };*/

      window.recognition.onresult = function (event) {
        //console.log(6);
        //console.log(event);
        //console.log(event);
        //console.log(event.results[0][0].transcript);
        setCurrenttext(event.results[0][0].transcript);
        if (event.results[0].isFinal) {
          //console.log(event.results[0][0].transcript);
          changeRecognised(event.results[0][0].transcript);
          setCurrenttext("");
          //console.log(inst.props.history);
          //inst.props.fetchSpeech(event.results[0][0].transcript, true, inst.handleLink, inst.props.history, inst.speechaction);
          //systemmsg
          //setTimeout(function(){ recstart() }, 100);
        }
      };
    }
  }, [recognised]);

  React.useEffect(() => {
    //.then((response) => /*console.log(response));
    /*axios
      .post(getHost() + "/transfer", {
        
      })
      .then((response) => console.log(response));*/
    try {
      fetch(getHost() + "/getreservationoption", {
        method: "get",
        headers: new Headers({
          "content-type": "application/json",
        }),
      })
        .then((response) => response.json())
        .then((data) => dispatch(setOptionOperators(data.ret)));
    } catch (e) {
      //console.log(e);
    }

    try {
      fetch(
        getHost() +
          "/getproperties?agencyid=" +
          window.configData.AGENCYID +
          "&tag=premiumrooms&language=de",
        {
          method: "get",
          headers: new Headers({
            "content-type": "application/json",
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          dispatch(
            setSpecialRoomTypes(
              data.properties.map((e) => {
                return e.label;
              })
            )
          );
          dispatch(
            setHotelSpecialRoomTypes(
              data.properties.map((e) => {
                return e.label;
              })
            )
          );
        });
    } catch (e) {
      //console.log(e);
    }

    let sessid = "";
    if (cookies) {
      if (!cookies.sessionid) {
        let sessionid = uuidv4();
        setCookie("sessionid", sessionid, {
          expires: new Date(2099, 1, 1),
          path: "/",
        });
        sessid = sessionid;
        dispatch(setSessionId(sessionid));
      } else {
        dispatch(setSessionId(cookies.sessionid));
        sessid = cookies.sessionid;
      }
      socket.emit("sessionid", sessid);

      if (cookies.lastsearch) {
        //console.log(cookies.lastsearch);
        let lastsearch = cookies.lastsearch;

        cookietosearch({ ret: [lastsearch] }, dispatch, true);
      }
    }
    //console.log("++++++++++", sessid);
    dispatch(fetchSessionHistory({ sessionid: sessid }));

    dispatch(fetchSuggestions());

    try {
      fetch(getHost() + "/getsessionmemo?sessionid=" + sessid)
        .then((response) => response.json())
        .then((data) => {
          //console.log("Success:", data);
          if (Array.isArray(data.ret)) {
            dispatch(setMemo(data.ret));
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (e) {
      //console.log(e);
    }
  }, [cookies]);

  React.useEffect(() => {
    //console.log(">>>>>>>>>>>>",view);
    if (
      //1 == 1
      view === views.bookingview ||
      view === views.searchview ||
      view === views.confirmationview ||
      view === views.tileview
    ) {
      if (document.getElementById("leftSidebar")) {
        dispatch(getAdvertising({ view: view, panel: "leftSidebar" }));
      }

      if (document.getElementById("rightSidebar")) {
        dispatch(getAdvertising({ view: view, panel: "rightSidebar" }));
      }
    }
  }, [view]);

  React.useEffect(() => {
    if (
      window.location.href.indexOf(window.configData.ACCOMMODATION_URL) > -1
    ) {
      dispatch(setUrlfound(true));
      dispatch(setHolidayType({ accommodation: true, flight: false }));
      dispatch(
        setSearchOption({
          property: "durationkind",
          data: {
            value: "OvernightStays",
          },
        })
      );
    }

    if (window.location.href.indexOf(window.configData.PACKAGE_URL) > -1) {
      dispatch(setUrlfound(true));
      dispatch(setHolidayType({ accommodation: true, flight: true }));
      dispatch(
        setSearchOption({
          property: "durationkind",
          data: {
            value: "Trip",
          },
        })
      );
    }

    //if (!window.tileView) {
    dispatch(fetchRegionGroups());
    dispatch(fetchDepartureStations());
    dispatch(fetchTourOperators());
    dispatch(fetchAirlines());
    //dispatch(fetchTravelAgencies());
    //}
    if (window.tileView) {
      dispatch(setView(views.tileview));
      /*fetch(getHost() + "/getbestplaces")
        .then((response) => response.json())
        .then((data) => {
          console.log("Success:", data);
          let arr = [];
          for (let i = 0; i < data.ret.length; i++) {
            arr.push({
              label: "Best " + (i + 1),
              RegionID: data.ret[i].HotelRegionID * 1,
            });
          }
          dispatch(setBestplaces(data.ret));
          //dispatch(setSelectedDestination(arr));

          //search(dispatch, false, false);
        })
        .catch((error) => {
          console.error("Error:", error);
        });*/
    }
  }, []);

  React.useEffect(() => {
    //console.log(parsed);
    if (parsed.features) {
      if (parsed.features === "1") {
        dispatch(setFeatures(true));
      }
    }

    if (parsed.mode) {
      if (parsed.mode) {
        dispatch(setMode(parsed.mode));
      }
    }

    if (parsed.debug) {
      if (parsed.debug === "1") {
        dispatch(setDebug(true));
      }
    }

    if (parsed.flights !== undefined) {
      if (parsed.flights === "1") {
        dispatch(setHolidayType({ accommodation: true, flight: true }));
      }
      if (parsed.flights === "0") {
        dispatch(setHolidayType({ accommodation: true, flight: false }));
      }
    }

    if (parsed.id) {
      try {
        fetch(getHost() + "/getlinkinfo?id=" + parsed.id)
          .then((response) => response.json())
          .then((data) => {
            //console.log("Success:", data);
            //console.log("Success:", data.ret[0]);
            dispatch(setMid(parsed.id));
            memotosearch(data, dispatch);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } catch (e) {
        console.log(e);
      }
    }

    if (parsed.hid) {
      try {
        fetch(getHost() + "/searchattributes?qid=" + parsed.hid, {
          method: "get",

          headers: new Headers({
            "content-type": "application/json",
          }),
        })
          .then((response) => response.json())
          .then((e) => {
            let hotel = {
              value: e.HotelName,
              label: e.HotelName,
              HotelCodes: e.HotelCodes,
              Name: e.HotelName,
            };
            dispatch(resetFilter(views.searchview));
            dispatch(setOutbounddate(""));
            dispatch(setInbounddate(""));
            dispatch(setSelectedDestination([hotel]));
            dispatch(setSelectedHotel(hotel));
            //console.log("E",e);
            //if(1==1) return;
            if (e.request?.stations) {
              let reqstats = e.request.stations.split(",");
              let stats = [];
              for (let i = 0; i < reqstats.length; i++) {
                stats.push({
                  value: reqstats[i],
                  label: airportcity(reqstats[i]),
                });
              }
              dispatch(
                setSearchOption({
                  property: "stations",
                  data: stats,
                })
              );
            }

            if (e.request?.adults)
              dispatch(
                setSearchOption({
                  property: "adults",
                  data: adultsOptions.find(
                    (o) => o.value === e.request.adults + ""
                  ),
                })
              );
            if (e.request?.children) {
              dispatch(
                setSearchOption({
                  property: "children",
                  data: childrenOptions.find(
                    (o) => o.value === e.request.children + ""
                  ),
                })
              );

              if (e.request?.childrenages) {
                let childrenages = [
                  { value: "0", label: "Alter" },
                  { value: "0", label: "Alter" },
                  { value: "0", label: "Alter" },
                  { value: "0", label: "Alter" },
                  { value: "0", label: "Alter" },
                  { value: "0", label: "Alter" },
                  { value: "0", label: "Alter" },
                  { value: "0", label: "Alter" },
                  { value: "0", label: "Alter" },
                  { value: "0", label: "Alter" },
                ];
                let tmpages = e.request.childrenages.split(",");
                if (Array.isArray(tmpages)) {
                  for (let i = 0; i < tmpages.length; i++) {
                    childrenages[i] = childrenAgeOptions.find(
                      (o) => o.value === tmpages[i] + ""
                    );
                  }
                }
                dispatch(
                  setSearchOption({
                    property: "childrenages",
                    data: childrenages,
                  })
                );
              }
            }
            //doSearch();
            search(dispatch, true, false);
            dispatch(setView(views.hotelcrossview));
          });
      } catch (e) {
        console.log(e);
      }
    }

    if (parsed.qid) {
      dispatch(setSidebar(false));
      try {
        fetch(getHost() + "/searchattributes?qid=" + parsed.qid, {
          method: "get",

          headers: new Headers({
            "content-type": "application/json",
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            dispatch(setSearchOptions(data));
            dispatch(setSaveSearch(true));

            if (data.selectedDestination.length > 0) {
              if (data.selectedDestination[0].HotelID) {
                dispatch(setOutbounddate(""));
                dispatch(setInbounddate(""));
                dispatch(setSelectedHotel(data.selectedDestination[0]));
                search(dispatch, true, false);
                dispatch(setView(views.hotelcrossview));
              } else {
                dispatch(setOutbounddate(""));
                dispatch(setInbounddate(""));
                search(dispatch, false, false);
                dispatch(setView(views.offerview));
              }
            }
            dispatch(setSaveSearch(false));
          });
      } catch (e) {
        console.log(e);
      }
    }

    if (parsed.hv && parsed.nqid) {
      dispatch(setSidebar(false));
      try {
        fetch(getHost() + "/searchattributes?qid=" + parsed.nqid, {
          method: "get",

          headers: new Headers({
            "content-type": "application/json",
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            dispatch(setSearchOptions(data.searchOptions));

            if (parsed.flights !== undefined) {
              if (
                data?.searchOptions?.durationkind?.value === "OvernightStays" &&
                parsed.flights === "1"
              ) {
                dispatch(
                  setSearchOption({
                    property: "durationkind",
                    data: {
                      value: "BetweenDepartures",
                      label: "Zwischen den Abreisen",
                    },
                  })
                );
              }

              if (parsed.flights === "0") {
                dispatch(
                  setSearchOption({
                    property: "durationkind",
                    data: { value: "OvernightStays", label: "Übernachtungen" },
                  })
                );
              }
            }

            dispatch(setSaveSearch(true));

            if (data.searchOptions.selectedDestination.length > 0) {
              if (data.searchOptions.selectedDestination[0].HotelID) {
                dispatch(setOutbounddate(""));
                dispatch(setInbounddate(""));
                dispatch(
                  setSelectedHotel(data.searchOptions.selectedDestination[0])
                );
                //search(dispatch, true, false);
                //dispatch(setView(views.hotelcrossview));
              } else {
                dispatch(setOutbounddate(""));
                dispatch(setInbounddate(""));
                //search(dispatch, false, false);
                //dispatch(setView(views.offerview));
              }
            }
            dispatch(setSaveSearch(false));
            let offer = data.offer;
            let hotel = data.hotel;
            if (parsed.hv === "crosscheck") {
              dispatch(setHotelOfferInfos({}));
              dispatch(setSelectedOfferId(offer.OfferID));

              dispatch(setSelectedHotel(hotel));
              dispatch(setHotelPage(1));
              dispatch(setOfferId(offer.OfferID));
              if (data.outbounddate) {
                dispatch(setOutbounddate(data.outbounddate));
              } else {
                //console.log(offer.OfferServices);
                dispatch(
                  setOutbounddate(
                    offer.OfferServices.Package?.Flight?.OutboundFlight
                      ?.FlightDeparture?.DepartureDate
                      ? offer.OfferServices.Package?.Flight?.OutboundFlight
                          ?.FlightDeparture?.DepartureDate
                      : offer.OfferServices.Package.Accommodation.CheckInDate
                  )
                );
              }

              /*dispatch(
                setInbounddate(
                  offer.OfferServices.Package?.Flight?.InboundFlight
                    ?.FlightArrival?.ArrivalDate
                    ? offer.OfferServices.Package?.Flight?.InboundFlight
                        ?.FlightArrival?.ArrivalDate
                    : offer.OfferServices.Package.Accommodation
                        .CheckOutDate
                )
              );*/
              dispatch(setInbounddate(""));
              dispatch(setApicall("packageOffers"));
              search(dispatch, true, false);
            }

            if (parsed.hv === "classic") {
              dispatch(setHotelOfferInfos({}));
              dispatch(setSelectedOfferId(offer.OfferID));
              dispatch(setSelectedHotel(hotel));
              dispatch(setHotelPage(1));
              dispatch(setOutbounddate(""));
              dispatch(setInbounddate(""));
              /*dispatch(
            setOutbounddate(
              offer.OfferServices.Package.Flight.OutboundFlight
                .FlightDeparture.DepartureDate
            )
          );*/
              dispatch(setApicall("touroperatoroffers"));
              search(dispatch, true, false);
            }

            if (parsed.hv === "crosscheck") {
              dispatch(setView(views.hotelcrossview));
            }

            if (parsed.hv === "classic") {
              dispatch(setView(views.hotelclassicview));
            }
          });
      } catch (e) {
        console.log(e);
      }
    }

    if (parsed.mid) {
      try {
        fetch(getHost() + "/getlinkinfo?id=" + parsed.mid)
          .then((response) => response.json())
          .then((data) => {
            //console.log("Searchlink MEMO");
            //console.log("Success:", data);
            //console.log("Success:", data.ret[0]);

            let arr = [];
            for (let i = 0; i < data.ret.length; i++) {
              let dat = data.ret[i];
              if (dat?.data);
              dat = dat.data;
              arr.push({
                label: dat.HotelName ? dat.HotelName : "Merkliste" + (i + 1),
                HotelCodes: {
                  HotelGiataID: dat.HotelGiataID * 1,
                  label: dat.HotelName ? dat.HotelName : "Favorit",
                  value: dat.HotelName ? dat.HotelName : "Favorit",
                  Name: dat.HotelName ? dat.HotelName : "Favorit",
                },
              });
            }
            //console.log(arr);
            if (arr.length > 0) {
              dispatch(setSelectedDestination(arr));

              search(dispatch, false, false);
              dispatch(setView(views.offerview));

              window.scrollTo(0, 0);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } catch (e) {
        console.log(e);
      }
    }
  }, []);

  /*
  const cancelLoading = () => {
    if ((loading === 0) && (cancelCounter === 0)) {
      setLoadanimation(false);
    }
    else if ((loading === 0) && (cancelCounter > 0)){
      setCancelCounter(cancelCounter-1)
      setTimeout(cancelLoading,1000);
    } else if((loading>0)&&(cancelCounter>0)) {
      setCancelCounter(2)
      setTimeout(cancelLoading,1000);
    }
  }


  if (loadanimation === true) {
    setTimeout(cancelLoading,1000);
  }

  if (loadanimation === false){
    if(loading>0){
      console.log("here");
      setLoadanimation(true);
      setCancelCounter(2);
    }
  }
*/
  return (
    <>
      {1 == 0 && (
        <div
          style={{
            borderRadius: "5px",
            position: "fixed",
            top: "25%",
            left: "25%",
            height: "50%",
            width: "50%",
            zIndex: 100000,
            //opacity: 0.2,
            //"-webkit-filter": "blur(5px)" /* Safari 6.0 - 9.0 */,
            //filter: "blur(5px)",
            //backdropFilter: "blur(25px)",
            //backgroundColor: "rgba(0,0,0,0.1)",
            verticalAlign: "middle",
            textAlign: "center",
            fontSize: "25pt",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
          }}
        >
          <Loading />
        </div>
      )}
      <div ref={appElement} className={"App"}>
        {/*JSON.stringify(parsed)*/}
        {/*view === views.tileview && <TileView />*/}

        {view === views.tileview && (
          <SearchFrameMain
            setRecognised={(txt) => setRecognised(txt)}
            currentText={currentText}
            recognised={recognised}
            smallForm={false}
            memo={memo}
          />
        )}

        {view === views.searchview &&
          !parsed.id &&
          !parsed.nqid &&
          !parsed.qid && (
            <SearchFrameMain
              setRecognised={(txt) => setRecognised(txt)}
              currentText={currentText}
              recognised={recognised}
              smallForm={false}
              memo={memo}
            />
          )}
        {view === views.searchview && parsed.id && (
          <div className="externsearch">Searching data...</div>
        )}
        {view === views.offerview && (
          <div
            style={{
              backgroundColor: "rgba(255,255,255,1)",
              minWidth: 1220,
              marginLeft: -10,
              borderRadius: 10,
              padding: 3,
            }}
          >
            <OffersView
              searchFrame={
                <SearchFrameMain
                  setRecognised={(txt) => setRecognised(txt)}
                  currentText={currentText}
                  recognised={recognised}
                  smallForm={true}
                  memo={memo}
                />
              }
            />
          </div>
        )}
        {view === views.hotelclassicview && (
          <div
            style={{
              backgroundColor: "rgba(255,255,255,1)",
              minWidth: 1220,
              marginLeft: -10,
              borderRadius: 10,
              padding: 3,
            }}
          >
            <HotelClassicViewView
              searchFrame={
                <SearchFrameMain
                  setRecognised={(txt) => setRecognised(txt)}
                  currentText={currentText}
                  recognised={recognised}
                  smallForm={true}
                  memo={memo}
                />
              }
            />
          </div>
        )}
        {view === views.hotelcrossview && (
          <div
            style={{
              backgroundColor: "rgba(255,255,255,1)",
              minWidth: 1220,
              marginLeft: -10,
              borderRadius: 10,
              padding: 3,
            }}
          >
            <HotelCrossViewView
              searchFrame={
                <SearchFrameMain
                  setRecognised={(txt) => setRecognised(txt)}
                  currentText={currentText}
                  recognised={recognised}
                  smallForm={true}
                  memo={memo}
                />
              }
            />
          </div>
        )}
        {view === views.bookingview && (
          <div
            style={{
              backgroundColor: "rgba(255,255,255,1)",
              marginLeft: -10,
              minWidth: 1220,
              borderRadius: 10,
              padding: 3,
            }}
          >
            <BookingView />
          </div>
        )}
        {view === views.confirmationview && (
          <div
            style={{
              backgroundColor: "rgba(255,255,255,1)",
              marginLeft: -10,
              minWidth: 1220,
              borderRadius: 10,
              padding: 3,
            }}
          >
            <ConfirmationView />
          </div>
        )}
        {view === views.flightsview && (
          <div
            style={{
              backgroundColor: "rgba(255,255,255,1)",
              marginLeft: -10,
              minWidth: 1220,
              borderRadius: 10,
              padding: 3,
            }}
          >
            <FlightsView
              searchFrame={
                <SearchFrameMain
                  setRecognised={(txt) => setRecognised(txt)}
                  currentText={currentText}
                  recognised={recognised}
                  smallForm={true}
                  memo={memo}
                />
              }
            ></FlightsView>
          </div>
        )}
      </div>
    </>
  );
}
